import { StatusBanner } from "@/components/StatusBanner";
import { SectionStatus } from "@/features/identity/components/SectionStatus";

export function SaveBar({ status, dirty, onSave, testId, label = "Save" }) {
  const saving = status.state === "saving";
  const problem = status.state === "error" || status.state === "invalid";
  return (
    <div className="space-y-3">
      {problem && <StatusBanner testId={`${testId}-error`}>{status.message}</StatusBanner>}
      <div className="flex items-center justify-between gap-4">
        <SectionStatus status={status} dirty={dirty} testId={`${testId}-status`} />
        <button type="button" onClick={onSave} disabled={!dirty || saving} data-testid={`${testId}-save-button`} className="mw-btn mw-btn-primary">
          {saving ? "Saving" : label}
        </button>
      </div>
    </div>
  );
}
